/* ATARA product page: gallery stage, hover zoom, full-screen viewer, variant images, description clamp */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var desk = window.matchMedia('(min-width: 990px)');
  var canHover = window.matchMedia('(hover: hover)');

  function initGallery(root) {
    var g = $('[data-gallery]', root);
    if (!g || g._on) return; g._on = true;
    var stage = $('.pdp__stage', g), track = $('.pdp__slides', g);
    var slides = $$('[data-slide]', g), thumbs = $$('[data-thumb]', g), dots = $$('.pdp__dots i', g);
    var counter = $('[data-gal-current]', g);
    var idx = 0;
    if (!slides.length) return;

    function show(i, fromScroll) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); t.setAttribute('aria-current', k === idx ? 'true' : 'false'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
      if (counter) counter.textContent = idx + 1;
      if (thumbs[idx] && desk.matches) thumbs[idx].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (!desk.matches && !fromScroll) slides[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      stage.classList.remove('is-zoom');
    }
    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function () { show(k); });
      t.addEventListener('mouseenter', function () { if (desk.matches && canHover.matches) show(k); });
    });
    var prev = $('[data-gal-prev]', g), next = $('[data-gal-next]', g);
    if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); show(idx - 1); });
    if (next) next.addEventListener('click', function (e) { e.stopPropagation(); show(idx + 1); });
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(idx + 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(idx - 1); }
      if (e.key === 'Enter') { e.preventDefault(); openViewer(idx); }
    });

    var st = null;
    track.addEventListener('scroll', function () {
      if (desk.matches) return;
      clearTimeout(st);
      st = setTimeout(function () {
        var r = track.getBoundingClientRect(), mid = r.left + r.width / 2, best = 0, bd = 1e9;
        slides.forEach(function (s, k) { var b = s.getBoundingClientRect(), d = Math.abs(b.left + b.width / 2 - mid); if (d < bd) { bd = d; best = k; } });
        if (best !== idx) show(best, true);
      }, 60);
    }, { passive: true });

    stage.addEventListener('pointermove', function (e) {
      if (!desk.matches || !canHover.matches || e.target.closest('button')) { stage.classList.remove('is-zoom'); return; }
      var img = $('img', slides[idx]);
      if (!img) return;
      var r = stage.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      stage.classList.add('is-zoom');
    });
    stage.addEventListener('pointerleave', function () { stage.classList.remove('is-zoom'); });

    var lb = null;
    function buildViewer() {
      lb = document.createElement('div');
      lb.className = 'lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'תמונות המוצר');
      var items = slides.map(function (s) {
        var im = $('img', s);
        if (!im) return '<div class="lb__item"></div>';
        return '<div class="lb__item"><img src="' + (im.getAttribute('data-full') || im.currentSrc || im.src) + '" alt="' + (im.alt || '').replace(/"/g, '&quot;') + '" loading="lazy"></div>';
      }).join('');
      var th = slides.length > 1 ? '<div class="lb__thumbs">' + slides.map(function (s, k) {
        var im = $('img', s); return '<button type="button" aria-label="תמונה ' + (k + 1) + '">' + (im ? '<img src="' + (im.currentSrc || im.src) + '" alt="">' : '') + '</button>';
      }).join('') + '</div>' : '';
      lb.innerHTML = '<div class="lb__bar"><span class="lb__count"></span><button class="lb__close" type="button" aria-label="סגירה"></button></div><div class="lb__track">' + items + '</div>' + th;
      document.body.appendChild(lb);
      var tr = $('.lb__track', lb), cnt = $('.lb__count', lb), tb = $$('.lb__thumbs button', lb);
      function mark(k) { cnt.textContent = (k + 1) + ' / ' + slides.length; tb.forEach(function (b, j) { b.classList.toggle('is-active', j === k); }); }
      lb._go = function (k, smooth) { tr.scrollTo({ left: -k * tr.clientWidth, behavior: smooth ? 'smooth' : 'auto' }); mark(k); };
      var t2 = null;
      tr.addEventListener('scroll', function () { clearTimeout(t2); t2 = setTimeout(function () { mark(Math.round(Math.abs(tr.scrollLeft) / tr.clientWidth)); }, 50); }, { passive: true });
      tb.forEach(function (b, j) { b.addEventListener('click', function () { lb._go(j, true); }); });
      $('.lb__close', lb).addEventListener('click', closeViewer);
      lb.addEventListener('click', function (e) { if (e.target.classList.contains('lb__item')) closeViewer(); });
      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('is-open')) return;
        var k = Math.round(Math.abs(tr.scrollLeft) / tr.clientWidth);
        if (e.key === 'Escape') closeViewer();
        if (e.key === 'ArrowLeft') lb._go(Math.min(slides.length - 1, k + 1), true);
        if (e.key === 'ArrowRight') lb._go(Math.max(0, k - 1), true);
      });
    }
    var lastFocus = null;
    function openViewer(k) {
      if (!lb) buildViewer();
      lastFocus = document.activeElement;
      lb.classList.add('is-open');
      document.documentElement.classList.add('no-scroll');
      requestAnimationFrame(function () { lb._go(k, false); });
      setTimeout(function () { lb._go(k, false); $('.lb__close', lb).focus(); }, 30);
    }
    function closeViewer() {
      lb.classList.remove('is-open');
      document.documentElement.classList.remove('no-scroll');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    track.addEventListener('click', function (e) {
      var s = e.target.closest('[data-slide]');
      if (!s || $('video', s)) return;
      openViewer(slides.indexOf(s));
    });
    var openBtn = $('[data-gal-open]', g);
    if (openBtn) openBtn.addEventListener('click', function (e) { e.stopPropagation(); openViewer(idx); });

    var dataEl = $('script[data-product-json]', root), product = null;
    try { product = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (err) { product = null; }
    if (product) {
      $$('[data-option-index] input', root).forEach(function (inp) {
        inp.addEventListener('change', function () {
          var id = ($('form[data-product-form] input[name="id"]', root) || {}).value;
          var v = product.variants.filter(function (x) { return String(x.id) === String(id); })[0];
          if (!v || !v.featured_media) return;
          var k = slides.map(function (s) { return s.getAttribute('data-media-id'); }).indexOf(String(v.featured_media.id));
          if (k > -1) show(k);
        });
      });
    }
    if (desk.addEventListener) desk.addEventListener('change', function () { show(idx, true); });
  }

  function initClamp(root) {
    $$('[data-clamp]', root).forEach(function (el) {
      if (el._on) return; el._on = true;
      if (el.scrollHeight < 260) return;
      el.classList.add('is-clamped');
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'pdp__more'; b.textContent = 'להמשך קריאה'; b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function () {
        var open = el.classList.toggle('is-clamped') === false;
        b.textContent = open ? 'פחות' : 'להמשך קריאה';
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (!open) el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
      el.insertAdjacentElement('afterend', b);
    });
  }

  function init(scope) {
    $$('[data-product-root]', scope).forEach(function (r) { initGallery(r); initClamp(r); });
  }
  if (document.readyState === 'complete') init(document); else document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();